import request from "@/utils/request";

export function getMaritalInfo() {
  return request({
    url: "marital/data",
    method: "post",
  });
}

export function requestMarital(
  file,
  file2,
  date,
  isMarriage,
  nationalCode,
  birthday,
  comment
) {
  let fileName = file == null ? "" : file.name;
  let fileName2 = file2 == null ? "" : file2.name;
  var fmData = new FormData();

  fmData.append("ActionDate", date);
  fmData.append("IsMarriage", isMarriage);
  fmData.append("NationalCodeHamsar", nationalCode);
  fmData.append("BirthDateHamsar", birthday);
  fmData.append("Comment", comment);
  fmData.append("image", file);
  fmData.append("fileName", fileName);
  fmData.append("image2", file2);
  fmData.append("fileName2", fileName2);

  return request({
    url: "marital/save",
    method: "post",
    data: fmData,
  });
}
export function getMaritalHistory() {
  return request({
    url: "marital/gethistory",
    method: "post",
  });
}

export function removeMaritalRequest(requestID, srlFile, SrlFileHamsar) {
  return request({
    url: "marital/remove",
    method: "post",
    data: {
      requestID: requestID,
      FileID: srlFile,
      FileHamsarId: SrlFileHamsar,
    },
  });
}

export function downloadAttach(requestID) {
  return request({
    url: "/marital/downloadattach",
    method: "post",

    data: { RequestID: requestID },
  });
}
